import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-prescripteurs-details',
  templateUrl: './operation-prescripteurs-details.component.html',
  styleUrls: ['./operation-prescripteurs-details.component.scss']
})
export class OperationPrescripteursDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
